<template>
  <div>
    <div
      v-for="(message, index) in messages"
      :key="index"
      class="message"
      :class="{own: message.created_by == userid}"
    >
      <template v-if="message.creator">
        <div
          v-if="index > 0 && messages[index-1].created_by != message.created_by"
          class="username"
        >
          {{ message.creator.username }}
        </div>
        <div
          v-if="index == 0"
          class="username"
        >
          {{ message.creator.username }}
        </div>
      </template>
      <div style="margin-top: 5px" />
      <div class="content">
        <div
          style="word-break: pre"
          v-text="message.message"
        />
        <v-btn
          v-if="message.file"
          :href="message.file.file_url"
          class="download-btn"
        >
          {{ $t('form.chat.file') }} ({{ message.file.type }})
        </v-btn>
        <div
          class="time"
          v-text="$d(parseTime(message.created_at), 'long')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    messages: { type: Array, required: true }
  },
  data () {
    return {};
  },
  computed: {
    userid () {
      return this.$store.getters['auth/user'].id;
    }
  },
  methods: {
    parseTime (time) {
      return moment(time).toDate();
    },
    imageLoad () {
      // this.$emit('imageLoad')
    }
  }
};
</script>

<style lang="scss" scoped>
.time {
  font-size: 12px;
  color: #444;
}

span.emoji {
  font-size: 20px;
  vertical-align: middle;
  line-height: 2;
}
</style>
